/* eslint-disable no-restricted-imports */
import { Typography, withStyles } from '@material-ui/core';
export { Typography } from '@material-ui/core';

export const SuccessLabel = withStyles((theme) => ({
  root: { color: theme.palette.success.main },
}))(Typography) as typeof Typography;
export const ErrorLabel = withStyles((theme) => ({ root: { color: theme.palette.error.main } }))(
  Typography,
) as typeof Typography;
